import React from 'react';

import { ProcessKind } from './graph/types';

export function enumToSelectOptions<T extends string>(enumObj: Record<string, T>) {
  return Object.entries(enumObj).map(([key, value]) => ({
    label: key,
    value
  }));
}

export function normalizeStringForTestId(label: string | undefined) {
  if (!label) {
    return '';
  }

  return `${label.toLowerCase().replaceAll(' ', '-').replaceAll('.', '-')}`;
}

export function getTextFromReactNode(node: React.ReactNode): string {
  if (typeof node === 'string') return node;
  if (typeof node === 'number') return String(node);
  if (!node) return '';

  const parts: string[] = [];
  React.Children.forEach(node, (child) => {
    if (typeof child === 'string' || typeof child === 'number') {
      parts.push(String(child));
    } else if (React.isValidElement(child)) {
      const text = getTextFromReactNode(child.props.children);
      if (text) parts.push(text);
    }
  });

  return parts.join('\n');
}

export const FAST_RUN_SUPPORTED_KINDS: ReadonlySet<string> = new Set<string>([
  ProcessKind.Reformat,
  ProcessKind.Join,
  ProcessKind.Aggregate,
  ProcessKind.Filter,
  ProcessKind.WindowFunction,
  ProcessKind.OrderBy,
  ProcessKind.Limit,
  ProcessKind.SetOperation,
  ProcessKind.Union,
  ProcessKind.Intersect,
  ProcessKind.Except,
  ProcessKind.Deduplicate,
  ProcessKind.SQLStatement,
  ProcessKind.Pivot,
  ProcessKind.DbPivot,
  ProcessKind.BQPivot,
  ProcessKind.DuckDBPivot
]);

export function isFastRunSupported(componentKind: string | undefined): boolean {
  return !!componentKind && FAST_RUN_SUPPORTED_KINDS.has(componentKind);
}
